import { Injectable } from '@angular/core';
import { OidcClientNotification, OidcSecurityService, PublicConfiguration } from 'angular-auth-oidc-client';
import appsetting from '../../assets/appsetting.json';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { map, catchError, retry } from 'rxjs/operators';
import { BehaviorSubject, Subject, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie';
import { FormGroup } from '@angular/forms';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  constructor(private http: HttpClient,public oidcSecurityService: OidcSecurityService,private router: Router, private cookieService: CookieService) { }

  manualLogin(userDetails: FormGroup){

    const params = new HttpParams({
      fromObject: {
        client_id: appsetting.oidcConfig.clientId,
        grant_type: 'password',
        username: userDetails.controls['userName'].value,
        password: userDetails.controls['password'].value,
        scope: 'email openid profile',
      }
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
      })
    };

    return this.http
      .post(appsetting.ADFSAuthToken, params, httpOptions)
      .pipe(
        map((responseData) => {
          let response : any = {};
          response =  responseData;
          this.cookieService.put('access_token',response.access_token);
          this.cookieService.put('id_token',response.id_token);
          this.cookieService.put('refresh_token',response.refresh_token);
          this.router.navigate(['/product-selection']);
          return response;
        }),
        catchError(errorRes => {
          return throwError(errorRes);
        }));

  }

  tokenRefresh(){
  }

  logout(){
    this.cookieService.removeAll();
    this.router.navigate(['/login']);
  }
}
